// React and Router imports
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Firebase imports
import { auth } from "../../firebase";

// Component imports
import DocumentationHomeComponent from "./DocumentationHomeComponent";
import Sidebar from "../shared/Sidebar";
import { useContextMenu } from "../shared/ContextMenu";
import { useQuickLinks } from "../../contexts/QuickLinksContext";

// Styles
import "../../css/DocumentationMainPage.css"
import "../../css/HomePage.css"
import "../../css/Create.css"

function DocumentationMainPage() {
    const { enhancedRightClickEnabled } = useQuickLinks();
    const [uid, setUid] = useState(null)
    const navigate = useNavigate();

    const loggedOutOptions = [
        {
            label: "Login",
            icon: <i className="fas fa-sign-in-alt"></i>,
            url: "/login",
            onClick: () => navigate("/login"),
        },
        {
            label: "Register",
            icon: <i className="fas fa-user-plus"></i>,
            url: "/register",
            onClick: () => navigate("/register"),
        },
        {
            label: "Try My Notebook",
            icon: <i className="fas fa-book"></i>,
            url: "/my-notebook",
            onClick: () => navigate("/my-notebook"),
        },
        {
            label: "Visit YouTube Channel",
            icon: <i className="fab fa-youtube"></i>,
            url: "https://www.youtube.com/@schoolofintology4062",
            onClick: () => window.open("https://www.youtube.com/@schoolofintology4062", "_blank", "noopener,noreferrer"),
        },
        {
            label: "Join Discord",
            icon: <i className="fab fa-discord"></i>,
            url: "https://discord.gg/DYkESHwgVA",
            onClick: () => window.open("https://discord.gg/DYkESHwgVA", "_blank", "noopener,noreferrer"),
        },
    ];

    const loggedInOptions = [
        {
            label: "Home",
            icon: <i className="fas fa-home"></i>,
            onClick: () => navigate("/"),
        },
        {
            label: "Your Documents",
            url: "/documentation",
            onClick: () => navigate("/documentation"),
        },
        {
            label: "Your Walkthroughs",
            url: "/walkthroughs",
            onClick: () => navigate("/walkthroughs"),
        },
        {
            label: "Your Notebook",
            url: "/my-notebook",
            onClick: () => navigate("/my-notebook"),
        },
        {
            label: "Your Workspace",
            url: "/workspaces",
            onClick: () => navigate("/workspaces"),
        },
        {
            label: "Account Settings",
            url: `/account/${uid}`,
            onClick: () => navigate(`/account/${uid}`),
        },
    ];

    // Use loggedInOptions if signed in, otherwise loggedOutOptions
    const menuOptions = uid ? loggedInOptions : loggedOutOptions;
    const { showContextMenu, ContextMenuComponent } = useContextMenu(menuOptions);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUid(user.uid)
            } else {
                setUid(null)
            }
        })

        return () => { unsubscribe() }
    }, [])

    // Theme cleanup on unmount



    return (
        <div
            className="DocumentationMainPage__div"
            onContextMenu={
                enhancedRightClickEnabled
                    ? (e) => {
                        e.preventDefault();
                        showContextMenu(e.clientX, e.clientY);
                    }
                    : undefined
            }
        >
            <Sidebar />

            <div className="DocumentationMainPage__main-content">
                <DocumentationHomeComponent />
            </div>
            {enhancedRightClickEnabled && ContextMenuComponent}
        </div>
    )

}

export default DocumentationMainPage
